import { push } from "connected-react-router";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CustomData from "pages/_components/CustomData/CustomData";
import GridTable from "pages/_components/GridTable/GridTable";
import { shape } from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";

const ExpirationPaymentItem = ({ paymentItem }) => {
    const dispatch = useDispatch();
    const option = [
        {
            func: () => dispatch(push(`/servicePayments/detail/${paymentItem.serviceId}/${paymentItem.hash}`)),
            text: "payments.service.option.pay",
            textType: "I18N",
        },
    ];

    return (
        <>
            <GridTable.Data columnStart={1}>
                <CustomData titleText={paymentItem.reference} valueText={paymentItem.companyName} />
            </GridTable.Data>
            {paymentItem.details.map((detail) => (
                <GridTable.Data key={`summary-bill-${detail.label}`}>
                    <CustomData titleText={detail.label} valueText={detail.value} />
                </GridTable.Data>
            ))}
            <GridTable.Data className="menu-mobile">
                <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={option} />
            </GridTable.Data>
        </>
    );
};

ExpirationPaymentItem.propTypes = {
    paymentItem: shape({}).isRequired,
};

export default ExpirationPaymentItem;
